export default {
  login: '登入',
  logout: '登出',
  captcha: '驗證碼',
  account: '帳號',
  password: '密碼',
  forgetPassword: '忘記密碼',
  rememberMe: '保持登入狀態',
  messages: {
    alreadyLogin: '上一個登入狀態沒有被正常登出<br>請問是否確定登入',
    requiredAccount: '帳號為必填項目',
    requiredPassword: '密碼為必填項目',
    requiredCaptcha: '驗證碼為必填項目',
    captchaInvalid: '驗證碼錯誤或逾時，請重新輸入',
    accountOrPasswordError: '帳號或密碼錯誤',
    loginTimeout: '登入狀態逾時，請重新登入',
    accountLocked: '登入失敗已達{times}次。<br>帳號已鎖定，請使用忘記密碼功能重設密碼。',
    passwordExpiredAlert: '密碼已過期，請登入後變更密碼。',
    passwordExpired: '密碼已過期，請前往變更密碼。',
    passwordExpiredNotify: '密碼將在 {year}/{month}/{date} {hour}:{minute}:{second} 過期，請問是否要繼續登入？'
  }
};
